import type { Document as RichTextDocument } from '@contentful/rich-text-types';
import type { LinkProps } from '@mui/material/Link';
import type { TypographyProps } from '@mui/material/Typography';

export type RichTextBlockKey = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'p' | 'link';

export type RichTextTypographyBlockKey = Exclude<RichTextBlockKey, 'link'>;

export type RichTextTypographyBlockProps = Omit<TypographyProps, 'children'>;

export type RichTextLinkBlockProps = Omit<LinkProps, 'children'>;

export type RichTextBlockPropsMap = Partial<
  Record<RichTextTypographyBlockKey, RichTextTypographyBlockProps>
> & {
  link?: RichTextLinkBlockProps;
};

export interface RichTextProps {
  content: RichTextDocument;
  className?: string;
  textId?: string;
  title?: string;
  variants?: Partial<
    Record<RichTextTypographyBlockKey, TypographyProps['variant']>
  >;
  blockProps?: RichTextBlockPropsMap;
  blockClasses?: Partial<Record<RichTextBlockKey, string>>;
}

export const DEFAULT_BLOCK_VARIANTS: Record<
  RichTextTypographyBlockKey,
  TypographyProps['variant']
> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  p: 'bodyMd',
};

export const BLOCK_COMPONENTS: Record<
  RichTextTypographyBlockKey,
  TypographyProps['component']
> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  p: 'p',
};
